console.log('js/structured_packages.js -> v0.1.0');
$(function() {
	/**
	 * Opens the modal to show the photos and the listing information
	 */

    $('.js-package-modal').click(function(){
		var $discountBadge = $(this).closest('label').find('.package-discount-badge').clone();
		$discountBadge.addClass('-on-modal').find('.discount-badge__tooltip').remove();

		if (!$discountBadge.length) {
			var tagContent = $('.listing-availability__discount-label').clone().children('svg').remove().end().text().trim();
			if (tagContent) {
				$discountBadge = $('<div class="package-discount-badge -on-modal"></div>').text(tagContent);
			}
		}

		setTimeout(function(){
			$('#inquiry_modal').modal('hide');
			var pack = $('.package-selection-item:checked');
			// get data
			var data = {};
			data.id = pack.attr('data-id');
			data.price = $('#listing-query-package-price-'+data.id).html().trim();

			data.arrival = $('#beauty_arrival_date').val() || $('.js-sc1-inquiry-modal-arrival:first').text();
			if (!data.arrival) {
				data.arrival = $("#arrival_date_select").val();
			};
			data.duration = $('.listing-query-box__duration').text().trim();
			data.isFlexibleDuration = pack.attr('data-is-flexible-duration') == 1 ? true : false

			data.title = pack.attr('data-title')
			data.subtitle = pack.attr('data-subtitle')
			data.people = {
				'icons':pack.attr('data-nr-persons-icons'),
				'title':pack.attr('data-nr-persons-title')
			};

			data.bedding = {
				'icons':pack.attr('data-bed-config-icons'),
				'title':pack.attr('data-bed-config-title').slice(0, -1).split(',').join(', ')
			};

			var roomFacilities = false;

			if (pack.attr('data-room-facilities') != '') {
				roomFacilities = true;
				data.roomFacilitiesTitle = pack.attr('data-room-facilities-title');
				data.roomFacilities = pack.attr('data-room-facilities').slice(0, -1).split(',');
				data.roomFacilitiesRaw = pack.attr('data-room-facilities-raw').slice(0, -1).split(',');
			}

			data.accommodationFacilities = pack.attr('data-accommodation-facilities').slice(0, -1).split(',');
			data.accommodationFacilitiesRaw = pack.attr('data-accommodation-facilities-raw').slice(0, -1).split(',');

			data.descriptions = {
				'room': pack.attr('data-room-description'),
				'accommodation': pack.attr('data-accommodation-description')
			};
			data.images = pack.attr('data-package-images').slice(0, -1).split(',');

			// structured package modal content
			var el = $('<div></div>');
			$(el).append('<div class="spm__gallery"></div>');
			var g = $(el).find('.spm__gallery');

			if (data.images.length > 0) {
				$(g).append('<div id="spm_swiper" class="swiper-container"><div class="swiper-wrapper"></div><div class="spm_swiper-next" onClick="spm_swiper.slideNext(500);gae(\'structured_packages\',\'sp_gallery_click_next\');"></div><div class="spm_swiper-prev" onClick="spm_swiper.slidePrev(500);gae(\'structured_packages\',\'sp_gallery_click_prev\');"></div></div>');
				$(g).append('<div class="spm_thumbnails"></div>');
				for(i=0;i<data.images.length;i++){
					$(g).find('.swiper-wrapper').append('<div class="swiper-slide filter-gingham" style="background-image:url('+data.images[i]+');"></div>');
					$(g).find('.spm_thumbnails').append('<div class="spm_thumb" data-index="'+i+'" onclick="spm_swiper.slideTo('+(i+1)+');" style="background-image:url('+data.images[i]+');"></div>');
				};
			};


			$(el).append('<div class="spm__description"></div>');
			var d = $(el).find('.spm__description');
			$(d).append('<p class="spm__title">'+data.title+'</div>');
			$(d).append('<p class="spm__subtitle">'+data.subtitle+'</div>');
			if ($discountBadge.length) $(d).append($discountBadge);


			$(d).append('<p class="spm_icon spm__people"><span class="spm_icon-image">'+data.people.icons+'</span><span class="spm_icon-text">'+data.people.title+'</span></div>');
			if(data.bedding.icons != '' && data.bedding.title != ''){
				$(d).append('<p class="spm_icon spm__bedding"><span class="spm_icon-image">'+data.bedding.icons+'</span><span class="spm_icon-text">'+data.bedding.title+'</span></div>');
			};

			$(d).append('<p class="spm_icon spm__arrival"><span class="spm_icon-image"><img src="/static/files/svg/arrival.svg"></span><span class="spm_icon-text">'+data.arrival+'</span></div>');

			if (data.isFlexibleDuration) {
				let priceIsIndicativeNote = $("#price_is_indicative_hidden").val()
				$(d).append('<p class="spm_icon spm__price"><span class="spm_icon-image"><img src="/static/files/svg/price.svg"></span><span class="spm_icon-text">'+data.price+' ('+priceIsIndicativeNote+')</span></div>');
			} else {
				$(d).append('<p class="spm_icon spm__price"><span class="spm_icon-image"><img src="/static/files/svg/price.svg"></span><span class="spm_icon-text">'+data.price+'</span></div>');
			}

			/*
			 * Room Facilities
			 */

			if (roomFacilities) {
				$(d).append('<h3 class="facilities-title">' + data.roomFacilitiesTitle + '</h3>');

				var facilitiesList = $('<div class="spm__block package__facilities facilities-list"></div>');
				for (var i = 0; i < data.roomFacilities.length; i++) {
					facilitiesList.append('<span class="spm_icon package__facilities__facility"><i class="ebs-icon ' + data.roomFacilitiesRaw[i] + '" data-icon></i> ' + data.roomFacilities[i] + '</span>');
				}

				$(d).append(facilitiesList);
			}

			if (data.descriptions.room) {
				$(d).append('<div class="spm__block spm__block-descriptions"><p class="spm__block-text">'+data.descriptions.room+'</p></div>');
			}
			$(d).append('<div class="spm__block spm__block-descriptions"><p class="spm__block-text">'+data.descriptions.accommodation+'</p></div>');

			$(d).append($('.listing-query-box__payments'));


			// check if package is isntant bookable
			let instantBooking = pack.hasClass('instant');
			var spmWrapper = $('<div class="spm_cta_wrapper"></div>')
			spmWrapper.append('<div class="spm_cta spm_cta-primary">' + $('.listing-query-box #inquiry-query-submit').text() + '</div>');
			if (!data.isFlexibleDuration && !instantBooking) spmWrapper.append('<div class="spm_cta spm_cta-secondary reservation">' + $('.listing-query-box #reservation-query-submit').text() + '</div>');
			if (!data.isFlexibleDuration && instantBooking) spmWrapper.append('<div class="spm_cta spm_cta-secondary instant-booking">' + $('.listing-query-box #instant-booking-query-submit').text() + '</div>');
			$(el).append(spmWrapper);

			// modal
			$('#structured_packages_modal .modal-body').html('').append(el);
			$('#structured_packages_modal').modal('show');

			$('body').css('overflow','hidden');
			$('#structured_packages_modal').on('hidden.bs.modal', function () {
				$('#structured_packages_modal').off('hidden.bs.modal');
				$('body').css('overflow','');
			});

			// POST RENDER EVENTS

			// fixed position workaround
			if($(window).width() < 768){
				$('#structured_packages_modal .spm_cta_wrapper').detach().appendTo('#structured_packages_modal .form-wrapper');
			};

			// gallery swiper
			window.spm_swiper = new Swiper ('#spm_swiper', {
				loop: true,
				autoplay: 1500,
				navigation: {
				nextEl: '.spm_swiper-next',
				prevEl: '.spm_swiper-prev',
				},
				onSlideChangeEnd: function(swiper){
					$('.spm_thumb').removeClass('active');
					$('.spm_thumb[data-index="'+swiper.realIndex+'"]').addClass('active');
				},
			});

			// inquiry button
			$('.spm_cta-primary').click(function(){
				gae('structured_packages','spm_sidebar_inquiry');
				$('#structured_packages_modal').modal('hide');
				$('#inquiry-query-submit').trigger('click');
			});

			// reservation button
			$('.spm_cta-secondary.reservation').click(function(){
				gae('structured_packages','spm_sidebar_reservation');
				$('#reservation-query-submit').trigger('click');
			});

			$('.spm_cta-secondary.instant-booking').click(function() {
				gae('structured_packages', 'spm_sidebar_instant_booking');
				$('#instant-booking-query-submit').trigger('click');
			});
		}, 150);

	});

	$('#inquiry_modal').on('show.bs.modal', function() {
		gae('listingPage','inquiry_modal-open');
		if ($('.package-selection-item:checked').closest('.package-option').find('.package-modal-cta').length){
			$('.js-inqmodal-package-modal-cta').removeClass('hide');
		} else {
			$('.js-inqmodal-package-modal-cta').addClass('hide');
		};
	});

	$('#inquiry_modal').on('hide.bs.modal', function() {
		gae('listingPage','inquiry_modal-close');
	});

});
